(function () {
  function money(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function drawer() {
    return document.getElementById('MiniCartDrawer');
  }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    document.documentElement.classList.add('mini-cart-open');
    document.body.classList.add('mini-cart-open');
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('mini-cart-open');
    document.body.classList.remove('mini-cart-open');
  }

  function renderCart(cart) {
    var body = document.querySelector('[data-mini-cart-body]');
    var subtotalEl = document.querySelector('[data-mini-cart-subtotal]');
    var totalEl = document.querySelector('[data-mini-cart-total]');
    var discountRow = document.querySelector('[data-mini-cart-discount-row]');
    var discountEl = document.querySelector('[data-mini-cart-discount]');

    if (!body) return;

    /* ===== SUBTOTAL (antes de descuentos) ===== */
    if (subtotalEl) {
      subtotalEl.textContent = money(cart.items_subtotal_price || 0);
    }

    /* ===== TOTAL (después de descuentos, antes de envío) ===== */
    if (totalEl) {
      totalEl.textContent = money(cart.total_price || 0);
    }

    /* ===== DESCUENTO REAL DE SHOPIFY ===== */
    var discountValue = cart.total_discount || 0;

    if (discountRow && discountEl) {
      if (discountValue > 0) {
        discountRow.style.display = 'flex';
        discountRow.style.justifyContent = 'space-between';
        discountEl.textContent = '-' + money(discountValue);
      } else {
        discountRow.style.display = 'none';
      }
    }

    /* ===== ITEMS ===== */
    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<p style="padding:12px 0;">Tu carrito está vacío.</p>';
      return;
    }

    body.innerHTML = cart.items
      .map(function (item) {
        var img = item.image
          ? item.image.replace(/(\.[a-z]+)$/, '_100x$1')
          : '';

        return (
          '<div class="mini-cart-item">' +
            '<div>' +
              (img ? '<img src="' + img + '" alt="">' : '') +
            '</div>' +
            '<div>' +
              '<p class="mini-cart-item-title">' +
                item.product_title +
              '</p>' +
              '<div class="mini-cart-item-meta">' +
                item.quantity +
                ' × ' +
                money(item.final_price) +
              '</div>' +
            '</div>' +
          '</div>'
        );
      })
      .join('');
  }

  function refreshCartAndOpen() {
    fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        renderCart(cart);
        openDrawer();
      });
  }

  /* ===== CERRAR MINI CART ===== */
  document.addEventListener('click', function (e) {
    if (e.target && e.target.matches('[data-mini-cart-close]')) {
      closeDrawer();
    }
  });

  /* ===== FUNCIÓN GLOBAL ===== */
  window.openMiniCart = refreshCartAndOpen;
})();
// ===== Interceptar Add to Cart en página de producto =====
document.addEventListener('submit', function (e) {
  var form = e.target;

  // Detecta el form de producto
  if (form.matches('form[action="/cart/add"]')) {
    e.preventDefault();

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(function () {
      if (window.openMiniCart) {
        window.openMiniCart();
      }
    })
    .catch(function (err) {
      console.error('Error al agregar al carrito', err);
    });
  }
});
